import { render, staticRenderFns } from "./Monaco.vue?vue&type=template&id=9c368edc&"
import script from "./Monaco.vue?vue&type=script&lang=js&"
export * from "./Monaco.vue?vue&type=script&lang=js&"
import style0 from "./Monaco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports